import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { TextcutRectangle } from '../types'
import { MainLayoutStateAction } from '../context/LayoutContext'
import mittEmitter from '../utils/mitt'

const useShowDuplicatePopup = (
  references: TextcutRectangle[],
  storeDispatch: React.Dispatch<MainLayoutStateAction>
) => {
  const navigate = useNavigate()
  const navigateRef = useRef(navigate)
  const storeDispatchRef = useRef(storeDispatch)
  useEffect(() => {
    const handler = (bindingGroupId: string) => {
      const rects = references.filter(
        (re) => re.bindingGroupId === bindingGroupId
      )
      const set = new Set<string>()
      rects.forEach((rect) => set.add(`${rect.fileId}::${rect.filePage}`))
      if (rects.length > 0 && set.size > 1) {
        storeDispatchRef.current({
          type: 'BATCH',
          payload: {
            openPopup: true,
            referenceGroup: rects,
          },
        })
      } else if (rects.length > 0 && set.size === 1) {
        navigateRef.current(`/file/${rects[0].fileId}`, {
          state: { page: rects[0].filePage, top: rects[0].top ?? 0 },
        })
      }
    }

    mittEmitter.on('SHOW_DUPLICATE_FINDINGS_POP_UP', handler)

    return () => {
      mittEmitter.off('SHOW_DUPLICATE_FINDINGS_POP_UP', handler)
    }
  }, [references])
}

export default useShowDuplicatePopup
